// Note: In Angular, this error code is 11. We're changing it to a unique value here
// so we can measure how many uncaught error redirects we get from each app.

export const M_FLIGHTS_ERROR_CODE = 18
